module.exports = __webpack_public_path__ + "img/bars-sort-sharp-light.00fe7351.svg";